import { unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-30b4292f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "merchant-day-new"
};
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 活动规则 ");
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 分享 ");
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "main-visual-wrapper"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "bottom-content"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src"];
const _hoisted_10 = ["src"];
const _hoisted_11 = ["src"];
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "task-progress-list"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
  class: "box-title"
};
const _hoisted_16 = ["src"];
const _hoisted_17 = {
  class: "task-info"
};
const _hoisted_18 = {
  key: 0,
  class: "special-text"
};
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 站外资源首次释放");
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 小红书、公众号宣发 ");
const _hoisted_22 = [_hoisted_19, _hoisted_20, _hoisted_21];
const _hoisted_23 = ["onClick"];
const _hoisted_24 = ["src"];
const _hoisted_25 = {
  key: 0,
  class: "max-text"
};
const _hoisted_26 = ["src"];
const _hoisted_27 = {
  key: 0,
  class: "detail-card"
};
const _hoisted_28 = {
  class: "detail-text"
};
const _hoisted_29 = {
  class: "detail-coin"
};
const _hoisted_30 = ["src"];
const _hoisted_31 = {
  key: 0,
  class: "limit-text"
};
const _hoisted_32 = {
  key: 1,
  class: "detail-card"
};
const _hoisted_33 = {
  class: "detail-text"
};
const _hoisted_34 = {
  class: "detail-coin"
};
const _hoisted_35 = ["src"];
const _hoisted_36 = {
  key: 0,
  class: "limit-text"
};
const _hoisted_37 = {
  key: 2,
  class: "detail-card"
};
const _hoisted_38 = {
  class: "detail-text"
};
const _hoisted_39 = {
  class: "detail-coin"
};
const _hoisted_40 = ["src"];
const _hoisted_41 = {
  key: 0,
  class: "limit-text"
};
const _hoisted_42 = ["onClick"];
const _hoisted_43 = {
  class: "bottom-fixed"
};
const _hoisted_44 = {
  key: 0,
  class: "add-btn-info"
};
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" 扫码添加矿场向导，辅助您找到最佳\"挖矿路线\" ");
const _hoisted_46 = ["src"];
import { onMounted, reactive, onBeforeUnmount } from "vue";
import { useStore } from 'vuex';
import { useRoute } from "vue-router";
import env from "md-base-tools/env";
import { ref, computed } from 'vue';
import router from '@/router';
import { GoBack, postWXMessage, mdToast, CopyContent } from "../../utils/tools";
import domain from "@/service/domain";
import ShareBox from "@@/common/ShareBox.vue";
import redirect from '@/service/redirect';
import { getSchemeUrl } from "@/utils/toolsApi";
import updateGuide from "../../components/task/red_note_update_guide.vue";
import merchantReceiveSuccess from "../../components/activity/merchant_receive_success.vue";
import commonQrcode from "../../components/activity/common_qrcode.vue";
import lowerdev from '@/service/lowerdev';
import { getActivityTaskList, receiveTaskGold } from "@/api";
export default {
  setup(__props) {
    const isFix = ref(0);
    const route = useRoute();
    const store = useStore();
    const showFloatTip = ref(false);
    const userClosedTip = ref(false);
    const activeDetailIndex = ref(null); // 当前激活的详情索引
    const userId = computed(() => store.state.user.userId);
    const ifLogin = computed(() => store.state.user.ifLogin);

    // 详情弹窗数据
    const detailData = {
      3: [
      // 众筹宝箱

      {
        text: '众筹上线',
        coins: 2000
      }, {
        text: '众筹提审',
        coins: 1500
      }, {
        text: '家居品类',
        coins: 500
      }],
      4: [
      // 破圈宝箱
      {
        text: '商家发布种草活动',
        coins: 2000
      }, {
        text: '10个用户上传截图',
        coins: 3000
      }, {
        text: '商家公示奖励名单',
        coins: 5000
      }],
      5: [
      // 邀新宝箱
      {
        text: '邀新成功',
        coins: 100,
        limit: '/限5次'
      }, {
        text: '新商家创意上线',
        coins: 500,
        limit: '/限3次'
      }, {
        text: '新商家发布众筹',
        coins: 1000,
        limit: '/限3次'
      }, {
        text: '新商家众筹上线',
        coins: 3000,
        limit: '/不限次数'
      }, {
        text: '新商家众筹成功',
        coins: 3500,
        limit: '/不限次数'
      }]
    };

    // 分享信息
    const share_1x1 = "https://p6.moimg.net/mdwxapp/merchant/wx_share_icon.jpg?x-oss-process=image/resize,w_350,h_350,m_lfit/format,jpg/quality,Q_80/auto-orient,1/sharpen,100/ignore-error,1";
    const share_5x4 = "https://p6.moimg.net/mdwxapp/merchant/mina_share_icon.jpg?x-oss-process=image/resize,w_600,h_480,m_lfit/format,jpg/quality,Q_80/auto-orient,1/sharpen,100/ignore-error,1";
    const shareInfo = {
      active_title: "",
      img: share_1x1,
      mina_app_name: "gh_7210ac3f1f08",
      mina_share_img: share_5x4,
      mina_share_path: `pages/webviewPages/content/content?url=${domain.wap}/mdactivity/fastsell/merchant_day`,
      msg_des: "挖矿夺金大作战，带你解锁流量秘籍！",
      qq_des: "",
      qq_share_url: `${domain.wap}/mdactivity/fastsell/merchant_day`,
      qq_title: "挖矿夺金大作战，带你解锁流量秘籍！",
      qr_img: share_1x1,
      qzone_share_url: `${domain.wap}/mdactivity/fastsell/merchant_day`,
      share_url: `${domain.wap}/mdactivity/fastsell/merchant_day`,
      sharelink_url: `${domain.wap}/mdactivity/fastsell/merchant_day`,
      small_code: "",
      weibo_des: "挖矿夺金大作战，带你解锁流量秘籍！" + `${domain.wap}/mdactivity/fastsell/merchant_day` + '（分享自@摩点）',
      weibo_share_url: `${domain.wap}/mdactivity/fastsell/merchant_day`,
      weibo_title: "",
      weixin_share_url: `${domain.wap}/mdactivity/fastsell/merchant_day`,
      wxTimeline_share_url: `${domain.wap}/mdactivity/fastsell/merchant_day`,
      wx_des: "",
      wx_title: "挖矿夺金大作战，带你解锁流量秘籍！"
    };
    const goal_task_list = ref([]);

    //依次为 周排名宝箱 专属宝箱 创意宝箱 众筹宝箱 破圈宝箱 邀新宝箱 
    const progressList = ref([{
      type: 'miner_rank',
      boxTitle: '周排名宝箱',
      btnTitle: '去获得',
      completed: false
    }, {
      task_id: 31,
      prize: '4000',
      boxTitle: '专属宝箱',
      btnTitle: '领取',
      completed: false
    }, {
      task_id: 32,
      prize: 1000,
      boxTitle: '创意宝箱',
      btnTitle: '发布创意',
      completed: false
    }, {
      type: 'total_project_prize',
      prize: 4000,
      boxTitle: '众筹宝箱',
      btnTitle: '发布众筹',
      completed: false
    }, {
      type: 'update_rednote_prize',
      prize: 10000,
      boxTitle: '破圈宝箱',
      btnTitle: '去破圈',
      completed: false
    }, {
      type: 'recommend_cp',
      prize: 5000,
      boxTitle: '邀新宝箱',
      btnTitle: '去邀请新商家',
      completed: false
    }]);

    // 页面状态
    const state = reactive({
      is_ip: false,
      statusBarH: 10,
      qrcodeUrl: '',
      showQrcode: false
    });

    // 滚动监听处理函数
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (!userClosedTip.value) {
        showFloatTip.value = scrollTop > 600;
      }
    };

    // 调用 mutation 触发分享
    const triggerChangeShareStatus = () => {
      store.commit('currentShareUpdate', {
        obj: 'share_info',
        value: shareInfo
      });
      store.commit('changeShareStatus', {
        obj: 'showShare'
      });
    };
    onMounted(() => {
      document.title = "挖矿夺金大作战";
      state.is_ip = route.query.is_ip == 1 ? true : false;

      //配置内嵌小程序-分享信息
      configMinaShre();

      // 已登录状态下请求金币信息&活动任务列表
      if (ifLogin.value) {
        // 已登录状态下请求活动任务列表
        requestActivityTaskList();
      }

      // 如果是APP端，设置状态栏颜色&获取设备信息
      if (env.isModianIos() || env.isModianAndroid()) {
        // eslint-disable-next-line no-undef
        graft.app({
          functionName: "webNavColor",
          functionParams: {
            statusBarColorIsWhite: '1'
          }
        });

        // eslint-disable-next-line no-undef
        graft.app({
          functionName: "onGetDeviceInfo",
          functionParams: {},
          callBack: e => {
            state.statusBarH = e.data.statusBarH;
          }
        });
      }

      // 添加滚动监听
      window.addEventListener('scroll', handleScroll);
    });
    onBeforeUnmount(() => {
      // 移除滚动监听
      window.removeEventListener('scroll', handleScroll);
      if (env.isWxApp()) {
        lowerdev.dynamicScript("https://res.wx.qq.com/open/js/jweixin-1.3.2.js");
      }
    });

    // 是否吸顶
    function handleStickyAction(is_fix) {
      isFix.value = is_fix ? 1 : 0;
    }

    // 请求活动任务列表
    async function requestActivityTaskList() {
      const {
        status,
        data,
        message
      } = await getActivityTaskList({
        is_activity: 1
      });
      if (status == 0) {
        goal_task_list.value = data.list || [];

        // 使用Map优化查找效率
        const taskMap = new Map(goal_task_list.value.map(task => [task.task_id, task]));

        // 一次遍历更新progressList
        progressList.value = progressList.value.map(item => {
          if (item.task_id && taskMap.has(item.task_id)) {
            const matchedTask = taskMap.get(item.task_id);
            return {
              ...item,
              prize: matchedTask.prize,
              completed: matchedTask.task_status == 20
            };
          }
          return item;
        });
      } else {
        mdToast(message || '获取数据失败');
      }
    }
    // 配置内嵌小程序-分享信息
    function configMinaShre() {
      // 小程序页面加载完毕才会接受分享配置
      setTimeout(() => {
        postWXMessage({
          title: '来摩点发众筹，一键解锁流量密码！',
          imageUrl: share_5x4,
          url: `${domain.wap}/mdactivity/fastsell/merchant_day`
        });
      }, 1000);
    }

    // 更新提示弹窗-复制链接
    function guideToPCUpdateAction(result) {
      showUpdateGuide.value = false;
      if (env.isMobile()) {
        CopyContent(result.event, `https://member.modian.com/project_manage/update/index/${result.pro_id}.html`);
      } else {
        //PC直接跳转
        window.location.href = 'https://member.modian.com/operate_manage/task';
      }
    }

    // 离开页面
    function handleGoBack() {
      GoBack();
    }

    // 任务规则
    function handleTaskRule() {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `${domain.wap}/mdactivity/merchant_day_rule`,
        webFun: () => {
          router.push({
            path: `/mdactivity/merchant_day_rule`
          });
        }
      });
    }

    // 分享
    function handleShareAction() {
      if (env.isModianIos() || env.isModianAndroid()) {
        // eslint-disable-next-line no-undef
        graft.app({
          functionName: 'openShareTool',
          functionParams: JSON.parse(JSON.stringify(shareInfo))
        });
      } else {
        triggerChangeShareStatus();
      }
    }
    const showMerchantReceiveSuccess = ref(false);
    const showUpdateGuide = ref(false);
    // 处理任务
    const handleTask = async item => {
      // 如果未登录，跳转登录页
      if (!userId.value) {
        return redirect.to('login');
      }
      if (item.type == 'miner_rank') {
        // 周排名宝箱
        goToTaskCenter();
        return;
      } else if (item.type == 'total_project_prize') {
        // 众筹宝箱-PC跳发起众筹页，其他端跳引导页
        // eslint-disable-next-line no-undef
        graft.app({
          functionName: "openController",
          functionParams: `md://create_project`,
          webFun: () => {
            if (env.isWxApp()) {
              // eslint-disable-next-line no-undef
              wx.miniProgram.navigateTo({
                url: '/pages/projectPages/project-initiate/project-initiate'
              });
            } else {
              window.location.href = 'https://account.modian.com/m/initiate';
            }
          }
        });
        return;
      } else if (item.type == 'update_rednote_prize') {
        // 破圈宝箱 
        showUpdateGuide.value = true;
        return;
      } else if (item.type == 'recommend_cp') {
        // 邀新宝箱
        // eslint-disable-next-line no-undef
        graft.app({
          functionName: "openController",
          functionParams: `${domain.wap}/mdactivity/fastsell/recommend`,
          webFun: () => {
            if (env.isWxApp()) {
              // eslint-disable-next-line no-undef
              wx.miniProgram.navigateTo({
                url: '/pages/activePages/recommmend/recommmend'
              });
            } else if (env.isMobile()) {
              router.push({
                path: `/mdactivity/fastsell/recommend`
              });
            } else {
              state.qrcodeUrl = `${domain.wap}/mdactivity/fastsell/recommend`;
              state.showQrcode = true;
            }
          }
        });
      }
      switch (item.task_id) {
        case 31:
          // 专属宝箱
          if (item.completed == false) {
            //请求列表
            const {
              status,
              message
            } = await receiveTaskGold({
              task_id: item.task_id
            });
            if (status == 0) {
              //请求列表
              showMerchantReceiveSuccess.value = true;
              requestActivityTaskList();
            } else {
              mdToast(message);
            }
          }
          break;
        case 32:
          // 创意宝箱
          // 发布创意
          // eslint-disable-next-line no-undef
          graft.app({
            functionName: "openController",
            functionParams: `md://publishIdea`,
            webFun: () => {
              if (env.isMobile()) {
                router.push({
                  path: `/idea/create`
                });
              } else {
                window.location.href = 'https://account.modian.com/initiate/category';
              }
            }
          });
          break;
        default:
          break;
      }
    };

    // 关闭悬浮提示
    const closeFloatTip = () => {
      showFloatTip.value = false;
      userClosedTip.value = true;
    };

    // 切换详情显示
    const toggleDetail = index => {
      // 只有最高可得的宝箱才能切换详情
      if (index === 3 || index === 4 || index === 5) {
        if (activeDetailIndex.value === index) {
          activeDetailIndex.value = null;
        } else {
          activeDetailIndex.value = index;
        }
      }
    };

    // 添加客服
    function goToKF() {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `md://mini_program?name=gh_7210ac3f1f08&path=pages/index/index?nextUrl=pages/webviewPages/content/content&url=https://m.modian.com/ip/webActivity/779`,
        webFun: () => {
          if (env.isWxApp()) {
            // eslint-disable-next-line no-undef
            wx.miniProgram.navigateTo({
              url: '/pages/webviewPages/content/content?url=https://m.modian.com/ip/webActivity/779'
            });
          } else {
            getWXSchemeUrl();
          }
        }
      });
    }

    // 获取微信 Scheme URL
    async function getWXSchemeUrl() {
      const param = {
        path: "/pages/index/index",
        query: `nextUrl=pages/webviewPages/content/content&url=https://m.modian.com/ip/webActivity/779`
      };
      const option = {
        jump_wxa: JSON.stringify(param)
      };
      const url = await getSchemeUrl(option);
      location.href = url;
    }

    // 前往任务中心
    function goToTaskCenter() {
      // 如果未登录，跳转登录页
      if (!userId.value) {
        return redirect.to('login');
      }

      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `${domain.wap}/score/task/index`,
        webFun: () => {
          if (env.isMobile()) {
            router.push({
              path: `/score/task/index`
            });
          } else {
            window.location.href = 'https://member.modian.com/operate_manage/task';
          }
        }
      });
    }

    // 推广中心
    function goToPromotionCenter() {
      // 如果未登录，跳转登录页
      if (!userId.value) {
        return redirect.to('login');
      }
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `${domain.wap}/score/promotion/index`,
        webFun: () => {
          router.push({
            path: `/score/promotion/index`
          });
        }
      });
    }
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_sticky = _resolveComponent("van-sticky");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_sticky, {
        onChange: handleStickyAction
      }, {
        default: _withCtx(() => [_createElementVNode("header", {
          class: _normalizeClass([{
            'headerAndroid': _unref(env).isModianAndroid()
          }]),
          style: _normalizeStyle({
            'padding-top': _unref(state).statusBarH + 'px'
          })
        }, [(_unref(env).isModianIos() || _unref(env).isModianIosNew() || _unref(env).isModianAndroid()) && !_unref(state).is_ip ? (_openBlock(), _createBlock(_component_van_image, {
          key: 0,
          class: _normalizeClass(["back-icon", {
            'isFix': isFix.value
          }]),
          "lazy-load": "",
          src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/merchant/nav_back.png', 56),
          onClick: _withModifiers(handleGoBack, ["stop"])
        }, null, 8, ["class", "src", "onClick"])) : _createCommentVNode("", true), _createElementVNode("div", {
          class: _normalizeClass(["rule-info", {
            'isFix': isFix.value
          }]),
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => handleTaskRule(), ["stop"]))
        }, [_createVNode(_component_van_image, {
          class: "icon",
          src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/merchant/nav_rule.png', 28)
        }, null, 8, ["src"]), _hoisted_2], 2), _createElementVNode("div", {
          class: _normalizeClass(["share-info", {
            'isFix': isFix.value
          }]),
          onClick: _cache[1] || (_cache[1] = _withModifiers($event => handleShareAction(), ["stop"]))
        }, [_createVNode(_component_van_image, {
          class: "icon",
          src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/merchant/nav_share.png', 28)
        }, null, 8, ["src"]), _hoisted_3], 2)], 6)]),
        _: 1
      }), _createElementVNode("div", {
        class: _normalizeClass(["content-wrapper", {
          'is_browser': !_unref(env).isModianAndroid() && !_unref(env).isModianIos()
        }])
      }, [_createElementVNode("img", {
        class: _normalizeClass(['main-visual', 'first-img']),
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/merchant/merchant_day_01.png', 750),
        alt: "挖矿夺金大作战"
      }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
        class: _normalizeClass(['main-visual', 'second-img']),
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/merchant/merchant_day_02.png', 750),
        alt: "带你解锁流量秘籍"
      }, null, 8, _hoisted_6), _createElementVNode("div", {
        class: _normalizeClass(['action-btn', 'card-one']),
        onClick: goToTaskCenter
      }, "去获得"), _createElementVNode("div", {
        class: _normalizeClass(['action-btn', 'card-two']),
        onClick: goToPromotionCenter
      }, "去兑换")]), _createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
        class: "main-visual",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/merchant/merchant_day_04.png', 750),
        alt: "挖矿夺金大作战"
      }, null, 8, _hoisted_8), _createElementVNode("img", {
        class: "main-visual",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/merchant/merchant_day_05.png', 750),
        alt: "挖矿夺金大作战"
      }, null, 8, _hoisted_9), _createElementVNode("img", {
        class: _normalizeClass(['main-visual', 'last-img']),
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/merchant/merchant_day_06.png', 750),
        alt: "挖矿夺金大作战"
      }, null, 8, _hoisted_10), _createElementVNode("img", {
        class: "task-progress-img",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/merchant/merchant_day_progress_back.png', 750),
        alt: "挖矿夺金大作战"
      }, null, 8, _hoisted_11), _createElementVNode("img", {
        class: "task-logo-img",
        src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/merchant/merchant_day_03.png', 750),
        alt: "挖矿夺金大作战"
      }, null, 8, _hoisted_12), _createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(progressList.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "task-progress-item",
          key: item.task_id || index
        }, [_createElementVNode("div", {
          class: "treasure-box",
          onClick: $event => handleTask(item)
        }, [_createElementVNode("div", _hoisted_15, _toDisplayString(item.boxTitle), 1), _createElementVNode("img", {
          class: "box-img",
          src: _ctx.$imgUrlFilter(index % 2 === 1 ? 'https://p6.moimg.net/mdwxapp/merchant/left_box.png' : 'https://p6.moimg.net/mdwxapp/merchant/right_box.png', 200),
          alt: "宝箱"
        }, null, 8, _hoisted_16)], 8, _hoisted_14), _createElementVNode("div", _hoisted_17, [index === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_22)) : item.prize ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "coin-amount",
          onClick: $event => toggleDetail(index)
        }, [_createElementVNode("img", {
          class: "coin-icon",
          src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/merchant/gold_small_icon.png', 34),
          alt: "金币"
        }, null, 8, _hoisted_24), _createElementVNode("span", null, _toDisplayString(item.prize), 1), index === 3 || index === 4 || index === 5 ? (_openBlock(), _createElementBlock("span", _hoisted_25, "最高可得")) : _createCommentVNode("", true), index === 3 || index === 4 || index === 5 ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          class: _normalizeClass(["detail-icon", {
            'rotate-icon': activeDetailIndex.value === index
          }]),
          src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/merchant/merchant_more_arrow.png', 32),
          alt: "已验证"
        }, null, 10, _hoisted_26)) : _createCommentVNode("", true), (index === 3 || index === 4 || index === 5) && activeDetailIndex.value === index ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(['detail-dropdown', index % 2 === 0 ? 'align-left' : 'align-right', 'detail-dropdown-' + index])
        }, [index === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_27, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailData[3], (item, itemIndex) => {
          return _openBlock(), _createElementBlock("div", {
            key: itemIndex,
            class: "detail-item"
          }, [_createElementVNode("div", _hoisted_28, _toDisplayString(item.text), 1), _createElementVNode("div", _hoisted_29, [_createElementVNode("img", {
            class: "coin-icon-small",
            src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/merchant/gold_small_icon.png', 34),
            alt: "金币"
          }, null, 8, _hoisted_30), _createElementVNode("span", null, _toDisplayString(item.coins), 1)]), item.limit ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(item.limit), 1)) : _createCommentVNode("", true)]);
        }), 128))])) : _createCommentVNode("", true), index === 4 ? (_openBlock(), _createElementBlock("div", _hoisted_32, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailData[4], (item, itemIndex) => {
          return _openBlock(), _createElementBlock("div", {
            key: itemIndex,
            class: "detail-item"
          }, [_createElementVNode("div", _hoisted_33, _toDisplayString(item.text), 1), _createElementVNode("div", _hoisted_34, [_createElementVNode("img", {
            class: "coin-icon-small",
            src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/merchant/gold_small_icon.png', 34),
            alt: "金币"
          }, null, 8, _hoisted_35), _createElementVNode("span", null, _toDisplayString(item.coins), 1)]), item.limit ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(item.limit), 1)) : _createCommentVNode("", true)]);
        }), 128))])) : _createCommentVNode("", true), index === 5 ? (_openBlock(), _createElementBlock("div", _hoisted_37, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailData[5], (item, itemIndex) => {
          return _openBlock(), _createElementBlock("div", {
            key: itemIndex,
            class: "detail-item"
          }, [_createElementVNode("div", _hoisted_38, _toDisplayString(item.text), 1), _createElementVNode("div", _hoisted_39, [_createElementVNode("img", {
            class: "coin-icon-small",
            src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/merchant/gold_small_icon.png', 34),
            alt: "金币"
          }, null, 8, _hoisted_40), _createElementVNode("span", null, _toDisplayString(item.coins), 1), item.limit ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(item.limit), 1)) : _createCommentVNode("", true)])]);
        }), 128))])) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true)], 8, _hoisted_23)) : _createCommentVNode("", true), _createElementVNode("div", {
          class: _normalizeClass(['action-btn', {
            'completed': item.completed
          }]),
          onClick: $event => handleTask(item)
        }, _toDisplayString(item.completed ? '已领取' : item.btnTitle), 11, _hoisted_42)])]);
      }), 128))])])], 2), _createElementVNode("div", _hoisted_43, [_createVNode(_Transition, {
        name: "slide-up"
      }, {
        default: _withCtx(() => [showFloatTip.value && (_unref(env).isModianIos() || _unref(env).isModianIosNew() || _unref(env).isModianAndroid() || _unref(env).isMobile()) ? (_openBlock(), _createElementBlock("div", _hoisted_44, [_hoisted_45, _createElementVNode("div", {
          class: "add-btn",
          onClick: goToKF
        }, "添加"), _createElementVNode("img", {
          class: "close-btn",
          src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/merchant/merchant_add_close.png', 36),
          onClick: closeFloatTip
        }, null, 8, _hoisted_46)])) : _createCommentVNode("", true)]),
        _: 1
      }), _createElementVNode("div", {
        class: "task-action-btn",
        onClick: goToTaskCenter
      }, " 前往任务中心 ")])]), showUpdateGuide.value ? (_openBlock(), _createBlock(updateGuide, {
        key: 0,
        show: showUpdateGuide.value,
        "onUpdate:show": _cache[2] || (_cache[2] = $event => showUpdateGuide.value = $event),
        onGuideToPCUpdateAction: guideToPCUpdateAction
      }, null, 8, ["show"])) : _createCommentVNode("", true), showMerchantReceiveSuccess.value ? (_openBlock(), _createBlock(merchantReceiveSuccess, {
        key: 1,
        show: showMerchantReceiveSuccess.value,
        "onUpdate:show": _cache[3] || (_cache[3] = $event => showMerchantReceiveSuccess.value = $event)
      }, null, 8, ["show"])) : _createCommentVNode("", true), _createVNode(ShareBox), _createVNode(commonQrcode, {
        url: _unref(state).qrcodeUrl,
        show: _unref(state).showQrcode,
        "onUpdate:show": _cache[4] || (_cache[4] = $event => _unref(state).showQrcode = false)
      }, null, 8, ["url", "show"])], 64);
    };
  }
};